import ScreenChat from 'pages/Users/Detail/_components/ChatHistory/ScreenChat';

const ChatHistory = () => {
  return (
    <div className="h-full p-4 bg-white w-full">
      <p className="font-bold text-xl mb-6">チャット履歴</p>
      <div className="h-[calc(100%-52px)]">
        <ScreenChat />
      </div>
    </div>
  );
};

export default ChatHistory;
